export enum DonorSource {
  Manual = 1,
  Google = 2,
  Facebook = 3
}
